<template>
  <div class="w-[90%] max-w-[1400px] mt-[30px] mx-auto flex flex-col pb-[30px]">
    <h2 class="text-sm font-medium text-white/60 text-left w-full mb-[10px]">{{ t('aiVideo.tools_banner') }}</h2>
    <div class="w-full max-w-[1400px] max-h-[480px] mx-auto rounded-[10px] overflow-hidden relative">
      <!-- Banner 视频骨架屏 -->
      <div v-if="!bannerLoaded" class="skeleton-box w-full aspect-video rounded-[10px]" />
      <video v-show="bannerLoaded" :poster="tool_banner?.img" :src="tool_banner?.video" autoplay muted loop
        preload="metadata" playsinline webkit-playsinline class="w-full h-full object-contain"
        @loadeddata="bannerLoaded = true" />
    </div>
    <h2 class="text-sm font-medium text-white/60 text-left w-full mt-[30px] mb-[10px]">{{ t('aiVideo.recommend_text') }}
    </h2>
    <ul class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 w-full">
      <li v-for="it in demo_list" :key="it.id" class="group relative flex-shrink-0 cursor-pointer"
        @click="handleMakeSimilar(it)">
        <!-- 列表视频骨架屏 -->
        <div v-if="!videoLoadedMap[it.id]" class="skeleton-box w-full aspect-[9/16] rounded-[10px]" />
        <video v-show="videoLoadedMap[it.id]" :poster="getResourceThumbnail(it.video)" :src="it.video" alt="Demo"
          class="w-full h-auto aspect-[9/16] object-cover rounded-[10px]" preload="metadata" playsinline loop
          webkit-playsinline muted @loadeddata="handleVideoLoaded(it.id)" @mouseenter="handleVideoHover($event, true)"
          @mouseleave="handleVideoHover($event, false)" />

        <div v-show="videoLoadedMap[it.id]"
          class="title-name absolute bottom-0 group left-0 right-0 z-[2] flex items-center justify-center">
          <p
            class="group-hover:opacity-0 absolute opacity-100 p-2 lg:text-lg text-sm font-medium text-white text-center w-full transition-opacity duration-300">
            {{ it.name }}</p>
          <button
            class="py-2 px-6 bg-[#99F768] absolute text-black text-sm font-normal leading-normal rounded-[12px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 ">
            {{ t('aiVideo.do_similar_text') }}
          </button>
        </div>

      </li>
    </ul>

  </div>



</template>
<script setup lang="ts">
import { getResourceThumbnail } from '@/utils/common'
import { inject, ref, reactive } from 'vue'
import { useI18n } from '~/composables/useI18n'

const { t } = useI18n()

const props = defineProps({
  demo_list: {
    type: Array as () => any[],
    default: () => [],
  },
  tool_banner: {
    type: Object,
    default: () => ({
      img: '',
      video: '',
    }),
  },
})

const handleMakeSimilar = inject('handleMakeSimilar') as (it: any) => void

// Banner 视频加载状态
const bannerLoaded = ref(false)

// 列表视频加载状态映射
const videoLoadedMap = reactive<Record<string | number, boolean>>({})

/**
 * 处理列表视频加载完成
 * @param id - 视频ID
 */
const handleVideoLoaded = (id: string | number) => {
  videoLoadedMap[id] = true
}

/**
 * 处理视频悬停播放/暂停
 * @param event - 鼠标事件
 * @param isHover - 是否悬停
 */
const handleVideoHover = (event: MouseEvent, isHover: boolean) => {
  const video = event.target as HTMLVideoElement
  if (isHover) {
    video.play()
  } else {
    video.pause()
  }
}


</script>
<style scoped lang="less">
.title-name {
  height: 60px;
  border-radius: 10px;
  font-family: Roboto;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.80) 100%);
}

/* 骨架屏样式 */
.skeleton-box {
  background: rgba(28, 28, 30, 0.8);
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}
</style>